// extracted by mini-css-extract-plugin
export var grid = "_2v-0";
export var span1 = "_2v-2";
export var span10 = "_2v-b";
export var span10L = "_2v-z";
export var span10M = "_2v-n";
export var span10Xl = "_2v-1b";
export var span11 = "_2v-c";
export var span11L = "_2v-10";
export var span11M = "_2v-o";
export var span11Xl = "_2v-1c";
export var span12 = "_2v-d";
export var span12L = "_2v-11";
export var span12M = "_2v-p";
export var span12Xl = "_2v-1d";
export var span1L = "_2v-q";
export var span1M = "_2v-e";
export var span1Xl = "_2v-12";
export var span2 = "_2v-3";
export var span2L = "_2v-r";
export var span2M = "_2v-f";
export var span2Xl = "_2v-13";
export var span3 = "_2v-4";
export var span3L = "_2v-s";
export var span3M = "_2v-g";
export var span3Xl = "_2v-14";
export var span4 = "_2v-5";
export var span4L = "_2v-t";
export var span4M = "_2v-h";
export var span4Xl = "_2v-15";
export var span5 = "_2v-6";
export var span5L = "_2v-u";
export var span5M = "_2v-i";
export var span5Xl = "_2v-16";
export var span6 = "_2v-7";
export var span6L = "_2v-v";
export var span6M = "_2v-j";
export var span6Xl = "_2v-17";
export var span7 = "_2v-8";
export var span7L = "_2v-w";
export var span7M = "_2v-k";
export var span7Xl = "_2v-18";
export var span8 = "_2v-9";
export var span8L = "_2v-x";
export var span8M = "_2v-l";
export var span8Xl = "_2v-19";
export var span9 = "_2v-a";
export var span9L = "_2v-y";
export var span9M = "_2v-m";
export var span9Xl = "_2v-1a";
export var stretch = "_2v-1";